import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("photoswipe controller connected");
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: 'a',
      pswpModule: PhotoSwipe,
      showHideAnimationType: 'zoom',
      initialZoomLevel: 'fit',
      maxZoomLevel: 2,
      bgOpacity: 1
    });

    this.lightbox.init();
  }
}
